<div class="loading-screen-wrapper acceptance-terms" *ngIf="loading">
  <div class="loading-screen-box">
    <div class="icon">
      <img src="assets/icon/logo_allya.gif" alt="">
    </div>
    <div class="title" 
         *ngIf="typeRedirection === 'goToSite'"
    >Desconto aplicado!
    </div>
    <div class="title"
        *ngIf="typeRedirection === 'modalCouponApp' ||
               typeRedirection === 'modalCouponRedirect' ||
               typeRedirection === 'modalCouponWhatsapp'"
    >Cupom copiado!
    </div>
    <div class="subtitle" 
         *ngIf="typeRedirection === 'goToSite' ||
                typeRedirection === 'modalCouponRedirect'"
    >Você está sendo direcionado para o site do parceiro...
    </div>
    <div class="subtitle"
         *ngIf="typeRedirection === 'modalCouponApp'"
    >Você está sendo direcionado para o aplicativo do parceiro...
    </div>
    <div class="subtitle"
         *ngIf="typeRedirection === 'modalCouponWhatsapp'"
    >Você está sendo direcionado para o whatsapp do parceiro...
    </div>
  </div>
  <div class="unredirected">
    Não foi direcionado automaticamente
    <a target='_blank'
       href="{{campaignLink}}"
       (click)="trackingEvent('[desconto-aplicado | cupom-copiado]:clique-aqui')"
    >Clique aqui</a>
  </div>
</div>